import React from "react";
import { observer } from "mobx-react-lite";
import { Chip, Divider } from "@mui/material";
import { FolderIcon } from "@heroicons/react/24/solid";
import { FileIcon, defaultStyles } from "react-file-icon";
import { useStore } from "../../helpers";
import { safe_get } from "../../report-visuals";
import ThumbnailImage from "../../components-new/Thumbnail";

const DetailRow = ({ label, value }: any) => (
    <div className="grid grid-cols-3 gap-4 py-3">
        <div className="font-medium text-gray-500">{label}</div>

        <div className="col-span-2 break-all text-common-black">{value || "-"}</div>
    </div>
);

const ViewFile = observer(() => {
    const { digitalArchiveStore } = useStore();

    const file = digitalArchiveStore.activeViewFile;

    if (!file) return null;

    const isFolder = safe_get(file, "is_folder", false);

    const mime = safe_get(file, "mimetype", "");

    const isImage = mime.startsWith("image/");

    const extension = safe_get(file, "s3key", "")?.split(".")?.pop()?.toLowerCase() || "";

    return (
        <div className="p-5">
            <div className="mb-6 flex justify-center">
                {isFolder ? (
                    <FolderIcon className="h-36 w-36" color="#F8C471" />
                ) : isImage ? (
                    <ThumbnailImage s3Key={file.s3key} bucket="urn-assets" width={420} height={260} />
                ) : (
                    <div className="w-32">
                        <FileIcon extension={extension} {...defaultStyles[extension]} />
                    </div>
                )}
            </div>

            <Divider />

            <DetailRow label="Title" value={file.title} />

            <Divider />

            <DetailRow label="Description" value={file.description} />

            <Divider />

            <DetailRow label="Type" value={isFolder ? "Folder" : "File"} />

            <Divider />

            <DetailRow label="Mime Type" value={file.mimetype} />

            <Divider />

            <DetailRow label="Date" value={file.update_time} />

            {/*<DetailRow label="File Name" value={file.filename} />*/}

            {/*<Divider />*/}

            {/*<DetailRow label="Uploaded By" value={file.created_by_name} />*/}

            {/*<Divider />*/}

            {/*<DetailRow label="Created On" value={file.created_at} />*/}

            {/*<Divider />*/}

            {/*<DetailRow label="Updated On" value={file.updated_at} />*/}

            {/*<Divider />*/}

            {/*<div className="py-4">*/}
            {/*    <Chip color={isFolder ? "warning" : "primary"} label={isFolder ? "Folder" : "File"} />*/}
            {/*</div>*/}
        </div>
    );
});

export default ViewFile;
